<app-content>
  <app-breadcrumbs>
    <li>
      Moje sprawy
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Moje sprawy
    </h2>
    @if (!loading()) {
      <div class='row'>
        <div class='col-md-6'>
          <div class='form-group'>
            <label for='name'>Szukaj sprawę</label>
            <input autocomplete='off' [(ngModel)]='filterValue' id='name' type='text'
                   placeholder='Szukaj po numerze sprawy' />
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-md-6'>
          <ul class='item-list'>
            @for (item of cases() | filterData: filterValue : false : "caseNumber"; track $index) {
              <li>
                <div>
                  <a [routerLink]='"/moje-sprawy/" + item?.uuid'>{{ item?.caseNumber || 'Szczegóły sprawy' }}</a>
                </div>
                <div>
                  <small>
                    Data utworzenia:
                    <strong>
                      {{ (item?.createdAt | date) || 'Brak danych' }}
                    </strong>
                  </small>
                  <small>Status:&nbsp;<strong>{{ item.status?.name || 'Nieznany' }}</strong></small>
                </div>
              </li>
            }
          </ul>
          @if (!(cases() | filterData: filterValue : false : "caseNumber").length) {
            <app-alert content='Brak wyników' [closable]='false'>
            </app-alert>
          }
        </div>
      </div>
    }
    @if (loading()) {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    }
  </section>
</app-content>
